import RefClient from 'ref-client-core';
import isolineRangePlugin from './isolineRange';
import isolineRouteTimeFormView from './isolineRouteTimeFormView';

RefClient.formViewsPlugin.register('isolineRange', isolineRangePlugin);
RefClient.formViewsPlugin.register(
  'isolineRouteTime',
  isolineRouteTimeFormView
);
